import { Button } from '@wedding-tech/ui/button'

import { useFormContext } from '@/lib/forms/context'
import { cn } from '@/lib/utils'

import { Spinner } from '../common/Spinner/Spinner'

type Props = {
  label?: string
  loadingLabel?: string
  className?: string
}

export const SubmitButton = ({
  label = 'ลงทะเบียน',
  loadingLabel = 'กำลังดำเนินการ...',
  className,
}: Props) => {
  const form = useFormContext()

  return (
    <form.Subscribe
      selector={(state) => ({
        canSubmit: state.canSubmit,
        isSubmitting: state.isSubmitting,
      })}
    >
      {({ canSubmit, isSubmitting }) => (
        <Button
          type="submit"
          disabled={!canSubmit || isSubmitting}
          className={cn(
            'text-foreground h-12 w-full cursor-pointer rounded-full border border-white bg-linear-to-r from-[#DA969C] to-[#F3B6BB] text-base font-bold tracking-wider shadow-[0_2px_8px_rgba(244,186,191,0.5)] transition-all hover:brightness-105 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50',
            className,
          )}
        >
          {isSubmitting ? (
            <>
              <Spinner className="mr-2 size-5 text-white" />
              {loadingLabel}
            </>
          ) : (
            label
          )}
        </Button>
      )}
    </form.Subscribe>
  )
}
